import React, { useState, useEffect } from "react";
import { doGet,doDelete } from "../services/api-service";
import {setMasterEdit} from "../actions"
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router";
import { useSelector,useDispatch } from "react-redux";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import Delete from "@material-ui/icons/Delete";
import DeleteForever from "@material-ui/icons/DeleteForever";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Grid from "@material-ui/core/Grid";
import ActionButton from "../components/ActionButton";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Select from "react-select";
import IconButton from "@material-ui/core/IconButton";
import Search from "@material-ui/icons/Search";

const PaMasterComponent = props => {
    const dispatch = useDispatch()
    const user = useSelector(state => state.user.user)    
    const { classes } = props;
    const [dataTable, setDataTable] = useState([]);
    const [tobeDelete, setTobeDelete] = useState(0)
    const [statusOptions, setStatusOptions] = useState([
        { value: 1, label: 'Active' },
        { value: 0, label: 'Inactive' }
    ])
    const [selectedStatus, setSelectedStatus] = useState({ value: 1, label: 'Aktif' })
    const [filterParams, setFilterParams] = useState({})
    const [page, setPage] = useState(1)

    const statusOnChange = (e) =>{
        setSelectedStatus(e)
    }

    const filter = async () => {
        const params = {
            status : selectedStatus!==null ? selectedStatus.value : null
        };

        setFilterParams(params)
        getData(page,params)
    };

    useEffect(() => {
        getData();
    }, []);

    const edit = (master)=>{
        dispatch(setMasterEdit(master))
        props.history.push("/pa/app/master/create")
    }

    const add = ()=>{
        dispatch(setMasterEdit())
        props.history.push("/pa/app/master/create")
    }    

    const confirmDelete = (data_id)=>{
        setTobeDelete(data_id)
    }

    const deleteData = async(data_id)=>{
        const params={id:data_id}
        setDataTable(dataTable.filter(data=>data.id!==data_id))
        //await doDelete("pa/master",params)
        setTobeDelete(0)
    }

    const getData = async (page = 1, params = {}) => {
        const updatedParams = {
            ...params,
            status: params.status !== undefined ? params.status : 1
        };

        const response = await doGet("pa/master", updatedParams);
        setDataTable(response.data);
    };

    return (
        <React.Fragment>
            <Grid
                container
                spacing={8}
                direction="column"
                className={classes.container}
            >
                <Grid container direction="row" alignContent="flex-start">
                    <Grid item xs={10}>
                        <Typography
                            variant="h6"
                            gutterBottom
                            className="animated slideInLeft"
                        >
                            PA Master
                        </Typography>
                    </Grid>

                    <Grid item xs={2} align="right">
                        <Fab
                            onClick={add}
                            size="small"
                            color="secondary"
                            aria-label="Add"
                            className={classes.fab}
                        >
                            <AddIcon />
                        </Fab>
                    </Grid>

                    <Grid container spacing={8} className={classes.filterContainer} >
                        <Grid item spacing={8} xs={9}container>
                         
              
                            <Grid item xs={4}>
                                <Select
                                    options={statusOptions}
                                    value={selectedStatus}
                                    onChange={statusOnChange}
                                    placeholder="Select Status"
                                    isClearable
                                />
                            </Grid>


                        </Grid>
        

                        <Grid item xs={2} container justify="flex-end" alignItems="baseline">
                            <IconButton  onClick={filter} color="primary" aria-label="search">
                                <Search />
                            </IconButton>

                        </Grid>
                    </Grid>

                    <Grid item xs={12} className={classes.tableWrapper}>
                        <div className={classes.table}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center">
                                            Name
                                        </TableCell>
                                        <TableCell align="center">
                                            Note
                                        </TableCell>
                                        <TableCell align="center">
                                            Creator
                                        </TableCell>
                                        <TableCell align="center">
                                            Status
                                        </TableCell>
                                        <TableCell align="center">
                                            
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {dataTable.length > 0 &&
                                        dataTable.map(row => (
                                            <TableRow key={row.id}>
                                                <TableCell align="center">
                                                    {row.name}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {row.note}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {row.created_by_name}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {row.status_value}
                                                </TableCell>
                                                <TableCell align="left" style={{width:250}}>
                                                    <ActionButton
                                                        title="edit"
                                                        type="icon-button"
                                                        for={["adm"]}
                                                        role={user.role}
                                                        action={()=>edit(row)}
                                                        icon={<EditIcon fontSize="small"/>}
                                                    />

                                                    {
                                                    tobeDelete!==row.id &&
                                                    <ActionButton
                                                        title="delete"
                                                        type="icon-button"
                                                        for={["adm"]}
                                                        role={user.role}
                                                        action={()=>confirmDelete(row.id)}
                                                        icon={<Delete />}
                                                    />
                                                    }
                                                    {
                                                    tobeDelete===row.id &&
                                                    <>are you sure ?
                                                    <ClickAwayListener onClickAway={()=>setTobeDelete(0)}>
                                                            <ActionButton
                                                                title="click again to delete"
                                                                type="icon-button"
                                                                for={["adm"]}
                                                                role={user.role}
                                                                action={()=>deleteData(row.id)}
                                                                icon={<DeleteForever />}
                                                            />
                                                    </ClickAwayListener>
                                                    </>
                                                    }
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                </TableBody>
                            </Table>
                        </div>
                    </Grid>
                </Grid>
            </Grid>


        </React.Fragment>
    );
};

const styles = theme => ({
    button_mini: {
        width: 30,
        height: 30,
        padding: 0
    },
    selectFilter: {
        marginTop: 5
    },
    container: {
        margin: -16
    },
    widthAction: {
        minWidth: 180
    },
    widthDate: {
        minWidth: 150
    },
    switchIcon: {
        height: 10,
        width: 10,
        color: "#ffffff"
    },
    fab: {
        marginTop: -30
    },
    tableWrapper: {
        
    },
    table: {
        border: "solid 1px RGB(204, 204, 204)",
        borderRadius: 5,
        display: "inline-block",
        width: "-webkit-fill-available",
        overflowX: "auto"
    }
});

export default withRouter(withStyles(styles)(PaMasterComponent));
